export function toTrimmedCategoryArray(category?: null | (null | string | undefined)[]): string[] {
    const result: string[] = [];
    if (!category) return result;
    for (const cat of category) {
        if (cat) {
            result.push(cat);
        } else {
            return result;
        }
    }
    return result;
}